import { Box } from '@mui/material'
import { styled } from '@mui/material/styles'

export const ContentBox = styled(Box)(({ theme, gap }) => ({
  height: `calc(var(--vh, 1vh) * 100 - ${gap})`,
  overflowY: 'auto',
  boxSizing: 'border-box',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
  paddingTop: gap === '0px' ? theme.spacing(4) : 0,
  paddingBottom: gap === '0px' ? theme.spacing(4) : 0,
  // '@media only screen and (max-device-height: 400px)': {
  //   paddingTop: 32,
  // },
}))
